import React from 'react';
import classNames from 'classnames';

import ListingVerifiedBadge from '../ListingVerifiedBadge/ListingVerifiedBadge';

import css from './ListingTitle.module.css';

/**
 * Renders a listing title with an optional verified badge.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Title content
 * @param {boolean} [props.isVerified] - Whether the verified badge should be shown
 * @param {string} [props.tooltipText] - Optional tooltip text for the badge
 * @param {string} [props.verifiedLabel] - Accessible label for the badge
 * @param {string} [props.className] - Additional class names for the root element
 * @param {string} [props.rootClassName] - Override class for the root element
 * @returns {JSX.Element}
 */
const ListingTitle = props => {
  const {
    children,
    isVerified = false,
    tooltipText,
    verifiedLabel,
    className,
    rootClassName,
  } = props;

  return (
    <span className={classNames(rootClassName || css.root, className)}>
      {children}
      {isVerified ? (
        <ListingVerifiedBadge
          className={css.badge}
          tooltipText={tooltipText}
          label={verifiedLabel}
        />
      ) : null}
    </span>
  );
};

export default ListingTitle;
